import React, { useState } from "react";
import Instruction from "./Instruction";
// Notice the updated import path pointing to the file inside the new folder
import ReportingForm from "./ReportingForm/ReportingForm"; 

export default function StolenReport() {
  const [reporting, setReporting] = useState(false);

  return (
    <div className="animate-fade-in transition-all duration-300">
      {reporting ? (
        <ReportingForm />
      ) : (
        <>
          <Instruction />
          <div className="flex justify-center mt-10">
            <button
              className="px-10 py-4 bg-blue-600 text-white font-bold rounded-xl text-lg shadow-md hover:bg-blue-700 hover:-translate-y-1 transition-all focus:ring-4 focus:ring-blue-600/30"
              onClick={() => setReporting(true)}
            >
              Start Reporting Process &rarr;
            </button>
          </div>
        </>
      )}
    </div>
  );
}